import React from "react";
import Icon from "../atoms/Icon";
import Select from "react-dropdown-select";
import colors from "react-multi-date-picker/plugins/colors";

const SelectModal = ({
  iconName,
  label,
  placeholder,
  values,
  onchange,
  able,
  id,
  wbox,
  Loading,
  defaultO,
  searchfunction,
  style,
  icon,
  stylebox,
  Style,
}) => {
  // Prepare default value for select
  const selectValue = [{ label: defaultO, value: defaultO }];

  // Custom renderer for no data
  const customNoDataRenderer = () => {
    return <div style={{ display: "none" }}></div>;
  };

  return (
    <div className={`flex flex-col ${style}`}>
      <label
        htmlFor=""
        className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
        {label}
      </label>
      <div
        className={`flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm ${stylebox}`}>
        {icon === false ? (
          <>
            <div className={`w-full ${Style}`}>
              {/* Select component */}
              <Select
                noDataLabel="داده ای یافت نشد"
                onChange={onchange}
                options={values}
                placeholder={able ? placeholder : ""}
                direction={"rtl"}
                style={{
                  width: wbox,
                  border: "none",
                  height: "54px ",
                  fontSize: "14px ",
                  paddingRight: "0px",
                  paddingLeft: "25px",
                  marginRight: "5px",
                  color: "#374170",
                  alignItems: "center",
                }}
                values={!able ? selectValue : undefined}
                searchFn={!Loading ? searchfunction : undefined}
                loading={Loading}
                noDataRenderer={customNoDataRenderer}
                closeOnSelect={true}
                dropdownHandleRenderer={({ state }) => (
                  // if dropdown is open show "–" else show "+"
                  <span>
                    {state.dropdown ? (
                      <Icon className=" w-3 h-3" iconName={"arrow-down"} />
                    ) : (
                      <Icon className=" w-3 h-3" iconName={"arrow-down"} />
                    )}
                  </span>
                )}/>
            </div>
          </>
        ) : (
          <>
            <Icon iconName={iconName} />
            <div className={`w-full ${Style}`}>
              {/* Select component */}
              <Select
                noDataLabel="داده ای یافت نشد"
                onChange={onchange}
                options={values}
                placeholder={able ? placeholder : ""}
                direction={"rtl"}
                style={{
                  width: wbox,
                  border: "none",
                  height: "54px ",
                  fontSize: "14px ",
                  paddingRight: "0px",
                  paddingLeft: "25px",
                  color: "#374170",
                  marginRight: "5px",
                  alignItems: "center",
                }}
                values={!able ? selectValue : undefined}
                searchFn={!Loading ? searchfunction : undefined}
                loading={Loading}
                noDataRenderer={customNoDataRenderer}
                closeOnSelect={true}
                dropdownHandleRenderer={({ state }) => (
                  // if dropdown is open show "–" else show "+"
                  <span>
                    {state.dropdown ? (
                      <Icon className=" w-3 h-3" iconName={"arrow-down"} />
                    ) : (
                      <Icon className=" w-3 h-3" iconName={"arrow-down"} />
                    )}
                  </span>
                )}/>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SelectModal;
